import OrderBookActionTypes from "../actionTypes/orderBook.actionTypes";
import { OrderBook } from "../proto/generated/security";
import { ActionType } from "./common.reducer";

interface OrderBookStateType {
    loading: boolean,
    orderBook: OrderBook | undefined
}

const initialState: OrderBookStateType = {
    loading: false,
    orderBook: undefined
};

export default function orderBookReducer(state = initialState, action: ActionType) {
    const {type, payload} = action

    switch (type) {
        case OrderBookActionTypes.SET_LOADING:
            return {
                ...state,
                loading: payload
            }

        case OrderBookActionTypes.SET_ORDER_BOOK:
            return {
                ...state,
                orderBook: payload
            }
        default:
            return state
    }
}
